/**
 * @file blendCustomer.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-10
 * @modified 2026-09-10
 * @description The sentinel for a blend with no account behind it.
 *
 *              Its own module rather than a constant exported from
 *              BlendCalculator: the details panel needs it too, and importing
 *              it from the calculator would close a circle — the calculator
 *              already imports the panel, and a cycle resolves to undefined at
 *              module-evaluation time depending on which side loads first.
 *
 *              Not an account id, and never confusable with one — every real
 *              value in that dropdown is a numeric string.
 */

export const PROSPECT = 'prospect';

export default PROSPECT;
